export default __webpack_public_path__ + "static/media/Lexend-Bold.b865ca33.ttf";